import { render, staticRenderFns } from "./TriviaWidget.vue?vue&type=template&id=599a5cc2&scoped=true"
import script from "./TriviaWidget.vue?vue&type=script&lang=js"
export * from "./TriviaWidget.vue?vue&type=script&lang=js"
import style0 from "./TriviaWidget.vue?vue&type=style&index=0&id=599a5cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599a5cc2",
  null
  
)

export default component.exports